import axios, { type AxiosError } from 'axios'
import { useStorage } from '@vueuse/core'

import { handleNotAuthorizedError } from '@core/router/handleAuthRedirects'
import { type CustomAxiosRequestConfig } from '@services/api/declarations'
// ***
// COMMON
// ***

const storage = useStorage('cluber', {
  auth: { token: '' },
}, localStorage)

// ***
// AXIOS INSTANCE
// ***

export const axiosInstance = axios.create()

// ***
// AXIOS INTERCEPTORS
// ***

axiosInstance.interceptors.request.use((config: CustomAxiosRequestConfig) => {
  const token = storage.value?.auth.token
  if (token && !config.skipToken) {
    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    await handleNotAuthorizedError(error as AxiosError, axiosInstance)
    return Promise.reject(error)
  },
)
